import i18n from "../../constants/i18n";
import ET3Div from "../../core/et3-div";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import et3ReadableDate from "../../helpers/et3-date-helper";
import getCorePersonalStore from "../../stores/core/core-personal-store";
import getCoreTimingStore from "../../stores/core/core-timing-store";
import getCoreUIStore from "../../stores/core/core-ui-store";
import getDashBoardStore from "../../stores/dashboard-store";
import HeaderEnvironmentChip from "./HeaderEnvironmentChip";
import HeaderSessionChip from "./HeaderSessionChip";
import {
  HEADER_CHIP_HEIGHT,
  HEADER_UTILITIES_GAP,
  HEADER_UTILITIES_WIDTH
} from "./header-constants";

const MILLISECONDS_IN_SECOND = 1000;

const HeaderUtilities = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX } = theme;
  const isAnyKhattabaAdmin = getCorePersonalStore().isAnyKhattabaAdmin.get();
  const isLoading = getCoreUIStore().isLatestDataLoading.get();
  const activeTime = getDashBoardStore().activeTime.get();
  const countDownTime = isAnyKhattabaAdmin
    ? getCoreTimingStore().khattabatCountDownTime.get() * MILLISECONDS_IN_SECOND
    : getCoreTimingStore().countDownTime.get() * MILLISECONDS_IN_SECOND;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={HEADER_UTILITIES_WIDTH}
      height={HEADER_CHIP_HEIGHT}
      fDirection="row"
      alignItems="center"
      justifyContent="flex-end"
      color={colors.all.transparent}
      style={{
        width: "auto",
        minWidth: 0,
        flexShrink: 0,
        gap: HEADER_UTILITIES_GAP * unitX
      }}
      onClick={() => {}}
    >
      <HeaderSessionChip
        activeLabel={`${i18n.get("ACTIVE")} ${et3ReadableDate(activeTime)}`}
        refreshLabel={et3ReadableDate(countDownTime)}
        isLoading={isLoading}
      />
      <HeaderEnvironmentChip />
    </ET3Div>
  );
});
export default HeaderUtilities;
